import { Component, Inject, Input, OnInit, ViewEncapsulation } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { ENTITLEMENTS, EntitlementsHelperService, LINE_OF_BUSINESS_ENUM, LOGIN_INFO_REDUCER_NAME, UserInfoStateStructure, USER_ROLE } from "@ptl/account-management";
import { AuthoringModeService } from "src/app/shared/services/authoring-mode.service";
import { ReducerUtilityService } from "src/app/shared/utility-services/reducer-utility.service";

@Component({
    selector: 'app-minnesota-pop-up-why',
    templateUrl: './minnesota-pop-up-why.component.html',
    styleUrls: ['./minnesota-pop-up-why.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class MinnesotaPopUpWhyComponent implements OnInit {


    // TODO: Please Delete this Component as soon as it is not needed because of these ridiculous requirements.
    constructor(
        private dialogRef: MatDialogRef<MinnesotaPopUpWhyComponent>,
        @Inject(MAT_DIALOG_DATA) public data: {}
    ) { }


    async ngOnInit() { }


    closeModal() {
        this.dialogRef.close();
    }

}